import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';

import { splitNumberWithCommas } from 'src/utils';
import { HoverWrapper } from 'src/components';
import {
  LikesCounterIcon,
  LikesCounterIconFilled,
  LikesCounterSt,
  LikesCounterText } from
'./impact-cards-ver.styled';
import { useSetImpactLike, useUnsetImpactLike } from 'src/hooks/actions';

interface IProps {
  count: number;
  userLiked: boolean;
  impactId: string;
}

export const LikesCounter = ({ count, userLiked, impactId }: IProps) => {
  const [liked, setLiked] = useState(userLiked);
  const { mutate: setLike, isLoading: isLiking } = useSetImpactLike();
  const { mutate: unsetLike, isLoading: isUnliking } = useUnsetImpactLike();
  const [t] = useTranslation();

  const handleToggleLike = () => {
    if (liked) {
      setLiked(false);
      unsetLike(impactId);
      return;
    }

    setLiked(true);
    setLike(impactId);
  };

  return (
    <LikesCounterSt id="likes-counter-component__components-impacts-cards-ver__likescounterst__l39">
      <HoverWrapper title={t('impact-likes-tooltip')}>
        <IconButton id="likes-counter-component__components-impacts-cards-ver__iconbutton__l41" onClick={handleToggleLike} size="small" disabled={isLiking || isUnliking}>
          {liked ? <LikesCounterIconFilled id="likes-counter-component__components-impacts-cards-ver__likescountericonfilled__l42" /> : <LikesCounterIcon id="likes-counter-component__components-impacts-cards-ver__likescountericon__l42" />}
        </IconButton>
      </HoverWrapper>
      <LikesCounterText id="likes-counter-component__components-impacts-cards-ver__likescountertext__l45">
        {splitNumberWithCommas(count + (userLiked && !liked ? -1 : !userLiked && liked ? 1 : 0))}
      </LikesCounterText>
    </LikesCounterSt>);

};